import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBhZ53NWlL-qiUlOi0icwMLeRyHiVDZ6SI",
  authDomain: "worshipers-unite.firebaseapp.com",
  projectId: "worshipers-unite",
  storageBucket: "worshipers-unite.firebasestorage.app",
  messagingSenderId: "839902349117",
  appId: "1:839902349117:web:f6fdb392212d34e2b92754"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);